"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeHttpUrl = safeHttpUrl;
const SAFE_PROTOCOLS = new Set(['http:', 'https:']);
/**
 * Returns the value unchanged when it parses as an absolute http(s) URL, otherwise undefined.
 * Parsing rather than prefix-matching is what catches schemes the URL constructor normalizes,
 * such as `java\tscript:`. The original string is returned rather than a re-serialized one so
 * that signed query parameters stay byte-identical.
 */
function safeHttpUrl(value) {
    if (!value)
        return undefined;
    try {
        return SAFE_PROTOCOLS.has(new URL(value).protocol) ? value : undefined;
    }
    catch {
        return undefined;
    }
}
//# sourceMappingURL=safe-url.js.map